/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetHealthcareFacilityDataDto } from './GetHealthcareFacilityDataDto';
import {
    GetHealthcareFacilityDataDtoFromJSON,
    GetHealthcareFacilityDataDtoFromJSONTyped,
    GetHealthcareFacilityDataDtoToJSON,
} from './GetHealthcareFacilityDataDto';
import type { GetDutyDto } from './GetDutyDto';
import {
    GetDutyDtoFromJSON,
    GetDutyDtoFromJSONTyped,
    GetDutyDtoToJSON,
} from './GetDutyDto';

/**
 * 
 * @export
 * @interface GetHealthcareFacilityDto
 */
export interface GetHealthcareFacilityDto {
    /**
     * 
     * @type {string}
     * @memberof GetHealthcareFacilityDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetHealthcareFacilityDto
     */
    displayName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetHealthcareFacilityDto
     */
    active?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetHealthcareFacilityDto
     */
    main?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetHealthcareFacilityDto
     */
    online?: boolean | null;
    /**
     * 
     * @type {GetDutyDto}
     * @memberof GetHealthcareFacilityDto
     */
    duty?: GetDutyDto | null;
    /**
     * 
     * @type {string}
     * @memberof GetHealthcareFacilityDto
     */
    dutyId?: string | null;
    /**
     * 
     * @type {Array<GetHealthcareFacilityDataDto>}
     * @memberof GetHealthcareFacilityDto
     */
    healthcareFacilityData?: Array<GetHealthcareFacilityDataDto> | null;
}

/**
 * Check if a given object implements the GetHealthcareFacilityDto interface.
 */
export function instanceOfGetHealthcareFacilityDto(value: object): value is GetHealthcareFacilityDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetHealthcareFacilityDtoFromJSON(json: any): GetHealthcareFacilityDto {
    return GetHealthcareFacilityDtoFromJSONTyped(json, false);
}

export function GetHealthcareFacilityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetHealthcareFacilityDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'active': json['active'] == null ? undefined : json['active'],
        'main': json['main'] == null ? undefined : json['main'],
        'online': json['online'] == null ? undefined : json['online'],
        'duty': json['duty'] == null ? undefined : GetDutyDtoFromJSON(json['duty']),
        'dutyId': json['dutyId'] == null ? undefined : json['dutyId'],
        'healthcareFacilityData': json['healthcareFacilityData'] == null ? undefined : ((json['healthcareFacilityData'] as Array<any>).map(GetHealthcareFacilityDataDtoFromJSON)),
    };
}

export function GetHealthcareFacilityDtoToJSON(value?: GetHealthcareFacilityDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'displayName': value['displayName'],
        'active': value['active'],
        'main': value['main'],
        'online': value['online'],
        'duty': GetDutyDtoToJSON(value['duty']),
        'dutyId': value['dutyId'],
        'healthcareFacilityData': value['healthcareFacilityData'] == null ? undefined : ((value['healthcareFacilityData'] as Array<any>).map(GetHealthcareFacilityDataDtoToJSON)),
    };
}

